import React, { ReactNode } from 'react';
import styled from 'styled-components';
import constants from '../common/theme/constants';

export enum KitButtonBarType {
  default,
  wizard,
}

const Container = styled.div<{ type: KitButtonBarType }>`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) =>
    props.type === KitButtonBarType.wizard ? 'space-between' : 'flex-end'};
  background-color: transparent;
  & button {
    margin-right: ${constants.spacing.absolute.s}px;
  }
  & button:last-child {
    margin-right: 0;
  }
  [dir='rtl'] & button {
    margin-right: 0;
    margin-left: ${constants.spacing.absolute.s}px;
  }
  [dir='rtl'] & button:last-child {
    margin-right: 0;
    margin-left: 0;
  }
`;

export interface KitButtonBarProps {
  className?: string;
  type?: KitButtonBarType;
  primary: ReactNode;
  secondary: ReactNode;
}

const KitButtonBar: React.FC<KitButtonBarProps> = ({
  className,
  type = KitButtonBarType.default,
  primary,
  secondary,
  ...rest
}: KitButtonBarProps) => {
  return (
    <Container className={className} type={type} {...rest}>
      {secondary}
      {primary}
    </Container>
  );
};

export default KitButtonBar;
